import { defineComponent, onMounted, PropType, ref } from "vue";
import { gsap, ScrollTrigger, SplitText } from "gsap/all";
import { Image } from "@/interfaces/Image";

gsap.registerPlugin(ScrollTrigger, SplitText);
export default defineComponent({
  props: {
    text: { type: String, required: false },
    textPosition: { type: String, default: "right" },
    image: { type: Object as PropType<Image>, required: true },
  },
  setup() {
    const textlines = ref<HTMLElement | null>(null);

    onMounted(() => {
      const splittext = new SplitText(".fullscreen_image__text", {
        type: "lines,words",
        linesClass: "fullscreen_image__text_line",
        wordsClass: "fullscreen_image__text_word",
      });

      // const tl = gsap.timeline({
      gsap.timeline({
        scrollTrigger: {
          trigger: textlines.value!.parentElement!.parentElement,
          start: "top 70%",
        },
      });

      for (let i = 0; i < splittext.lines.length; i++) {
        // tl.from(
        //   splittext.lines[i].querySelectorAll(".fullscreen_image__text_word"),
        //   {
        //     opacity: 0,
        //     yPercent: 100,
        //     duration: 1.5,
        //     ease: "power4.out",
        //   },
        //   (i - 1) * 0.1
        // );
      }

      gsap.to(".fullscreen_image__text", {
        yPercent: 100,
        ease: "none",
        scrollTrigger: {
          trigger: splittext.lines[0],
          scrub: true,
        },
      });
    });

    return { textlines };
  },
});
